import React, { useState, useEffect } from 'react';
import { dragAndDropStyle, thumbStyle } from "../../../../../theme/theme";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { getImageFileType } from "../../../../../utils/utils";

const theme = createMuiTheme({
  overrides: {
    MuiTypography: {
      body1: {
        fontFamily: "Avenir, sans-serif",
        fontSize: "12px",
        color: "#333333"
      },
      caption: {
        display: 'block',
        fontFamily: "Avenir, sans-serif",
        fontSize: "12px",
        color: "#333333",
        margin: 0,
        padding: 0
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: "2.1rem",
      }
    },
    MuiCheckbox: {
      root: {
        "&$checked": {
          "& svg": {
            fill: "#DA3732",
          },
        },
      },
    },
    MuiFormControlLabel: {
      root: {
        display: 'flex',
      },
    },
  }
});

function OtherFilesTable(props) {
  const {
    fileAccepted,
    fileName,
    fileSize,
    previewLink,
    uploadedFileIcon
  } = dragAndDropStyle();

  const {
    thumb,
    thumbInner,
    img
  } = thumbStyle();

  const {
    files,
    maxFilesAllowed,
    handlePreviousSavedfiles
  } = props;

  const filesNames = files.map(file => file.checked ? [file.name, file.checked] : [file.name, false]);
  const [checked, setChecked] = useState(new Map(filesNames));

  useEffect(() => {
    if (maxFilesAllowed === 0) {
      checked.clear();
      handlePreviousSavedfiles(checked);
    } else {
      let totalValues = [...checked.entries()];
      let checkedTrueFiles = [];
      totalValues.forEach(value => {
        if (value[1] && !checkedTrueFiles.includes(value[0])) {
          checkedTrueFiles.push(value[0])
        }
      });
      for (let i = checkedTrueFiles.length; i > maxFilesAllowed; i--) {
        checkedTrueFiles.splice(-1, 1);
      }
      totalValues.forEach(value => value[1] = checkedTrueFiles.includes(value[0]) ? true : false);
      let newChecked = new Map(totalValues);
      setChecked(newChecked);
      handlePreviousSavedfiles(newChecked);
    }
    // eslint-disable-next-line
  }, [maxFilesAllowed]);

  const handleChange = (name) => {
    const newMap = new Map([...checked.entries()]);
    const newValue = newMap.get(name);
    newMap.set(name, !newValue);
    setChecked(newMap);
    handlePreviousSavedfiles(newMap);
  };

  const isDisabled = (id) => {
    let stateValues = [...checked.entries()];
    let stateFiles = [];
    stateValues.forEach(value => {
      if (value[1] && !stateFiles.includes(value[0])) {
        stateFiles.push(value[0])
      }
    });
    return stateFiles.length >= maxFilesAllowed && stateFiles.indexOf(id) === -1
  }

  const fileLink = (file) => {
    return <a
      style={previewLink}
      target="_blank"
      rel="noopener noreferrer"
      href={file.path}
    >{file.name}</a>
  }

  const fileError = (file) => {
    if (getImageFileType(file.type)) {
      return (
        <img
          src={file.path}
          className={img}
          alt={file.name}
        />
      )
    } else if (file.type.includes(".pdf")) {
      return (
        <PictureAsPdfIcon style={uploadedFileIcon} />
      );
    } else {
      return (
        <CheckCircleOutlineOutlinedIcon style={uploadedFileIcon} />
      );
    }
  }

  return (
    <React.Fragment>
      <h4 style={{ margin: "0 0 15px 0" }}>Documents Uploaded for Other Transactions</h4>
      {files.map((file) => {
        return (
          <div key={file.name} style={{ width: "100%" }}>
            <table id={file.name} style={fileAccepted}>
              <tbody>
                <tr>
                  <td rowSpan="3" style={{
                    width: "15%",
                    verticalAlign: "top",
                    display: "table-cell",
                    padding: 0,
                  }}>
                    <div id="file-thumb" className={thumb}>
                      <div className={thumbInner}>
                        {fileError(file)}
                      </div>
                    </div>
                  </td>
                  <td style={{
                    width: "55%",
                    verticalAlign: "top",
                    display: "table-cell",
                    padding: "10px 0px 0px 0px",
                  }}>
                    <span variant="body1" style={fileName}>
                      {fileLink(file)}
                    </span>
                  </td>
                  <td style={{
                    width: "20%",
                    verticalAlign: "top",
                    display: "table-cell",
                    padding: "10px 0px 0px 0px",
                    textAlign: "right",
                  }}>
                    <span variant="body1" style={fileSize}>{file.size}</span>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" style={{
                    verticalAlign: "top",
                    display: "table-cell",
                    padding: 0,
                  }}>
                    <ThemeProvider theme={theme}>
                      <FormControlLabel
                        id={file.name}
                        htmlFor={file.name}
                        label={"This document includes required information for this transaction."}
                        tabIndex="0"
                        onClick={(event) => event.stopPropagation()}
                        onFocus={(event) => event.stopPropagation()}
                        control={
                          <Checkbox
                            id={file.name}
                            name={file.name}
                            color="secondary"
                            onClick={() => handleChange(file.name)}
                            checkedIcon={<CheckBoxOutlinedIcon />}
                            checked={checked.get(file.name) || false}
                            disabled={maxFilesAllowed <= 0 ? true : (isDisabled(file.name) || false)}
                          />
                        }
                      />
                    </ThemeProvider>
                  </td>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })
      }
    </React.Fragment>
  );
}

export default OtherFilesTable;
